import { word } from "@modules/core/utils/i18n"
import { AthleteNote } from "@modules/sessionBlock/notes/noteTypes"
import { HUText } from "@modules/ui/components/huText"
import { HURichTextView } from "@modules/ui/components/richText/huRichTextView"
import { formatTextToRichText } from "@modules/ui/components/richText/richTextUtils"
import { useTheme } from "styled-components"

type Props = {
  note: AthleteNote
  displayDetailedEvents: boolean
} & React.HTMLAttributes<HTMLDivElement>

export const NoteForAthletesInEvent: React.FC<Props> = ({ note, displayDetailedEvents, ...props }) => {
  const theme = useTheme()
  return (
    <div className="flex flex-column gap-1" {...props}>
      <HUText color={theme.neutralColor700} fontStyle="LXS" className="uppercase">
        {word("sessionForm.blocks.note_for_athletes")}
      </HUText>
      <HURichTextView
        value={formatTextToRichText(note.note)}
        paragrapheFontStyle="BS"
        numberOfLine={displayDetailedEvents ? undefined : 3}
        className="font-italic"
      />
    </div>
  )
}
